module.exports = __webpack_public_path__ + "static/img/lb_img_3.dc939ca5.png";